import * as React from "react";
import { Button, ButtonSize, DropdownMenu, MenuItem, Toast } from "react-ui";
import { NetDownloadIcon } from "@skbkontur/icons";

import { TableType } from "../../../Engine/Core/ModalManager/Modals/Utils/Types";
import { Icon } from "../../Icons/Icon";
import { EXCEL_DOWNLOAD_BUTTON_CLICK, EXCEL_UPLOAD_BUTTON_CLICK, XML_UPLOAD_BUTTON_CLICK } from "../../metricsAction";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { FufCombineMethod } from "../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";

export interface DropDownButtonLoadProps {
    pathToTable: string;
    disabled?: boolean;
    size?: ButtonSize;
    width?: number | string;
    downloadExcel: () => Promise<boolean>;
    uploadExcel: () => void;
    "data-tid"?: string;
    currentGfv: string;
    text: string;
    textInLoading?: string;
    tableType: TableType.static | TableType.dynamic;
    combineType: FufCombineMethod.AddToEnd | FufCombineMethod.Merge;
    onSaveForm: () => Promise<void>;
    uploadXml: () => void;
}

export function DropDownButtonUploadFiles(props: DropDownButtonLoadProps): JSX.Element {
    const track = useMetrics();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    async function refreshExcelDownload() {
        Toast.close();
        await downloadExcel();
    }

    async function downloadExcel() {
        await props.onSaveForm();
        track(EXCEL_DOWNLOAD_BUTTON_CLICK, { path: props.pathToTable });
        setIsLoading(true);
        const isSuccessResponse = await props.downloadExcel();
        if (!isSuccessResponse) {
            Toast.push("Не удалось скачать файл", {
                label: "Повторить",
                handler: refreshExcelDownload,
            });
        }
        setIsLoading(false);
    }

    async function uploadExcel() {
        track(EXCEL_UPLOAD_BUTTON_CLICK, { path: props.pathToTable });
        props.uploadExcel();
    }

    function uploadXml() {
        track(XML_UPLOAD_BUTTON_CLICK, { path: props.pathToTable });
        props.uploadXml();
    }

    return isLoading ? (
        <Button
            data-tid={props["data-tid"]}
            disabled={props.disabled}
            size={props.size}
            width={126}
            narrow={true}
            loading={isLoading}
            icon={<NetDownloadIcon />}>
            {isLoading ? props.textInLoading : props.text}
        </Button>
    ) : (
        <DropdownMenu
            data-tid={props["data-tid"]}
            disableAnimations
            caption={
                <Button size={props.size} data-tid={props["data-tid"]}>
                    {props.text} <Icon name={"ArrowCDownIcon"} />
                </Button>
            }>
            <MenuItem data-tid={"DownloadExcel"} onClick={downloadExcel}>
                Скачать таблицу в Excel
            </MenuItem>
            <MenuItem data-tid={"UploadExcel"} onClick={uploadExcel} comment={"Используйте скачанную таблицу"}>
                Загрузить таблицу из Excel
            </MenuItem>
            <MenuItem data-tid={"UploadXml"} onClick={uploadXml} comment={"Используйте файл установленного формата"}>
                Загрузить таблицу из Xml
            </MenuItem>
        </DropdownMenu>
    );
}
